<template>
  <div>
    <el-form :inline="true" class="style1">
      <el-form-item>
        <el-button class="el-icon-circle-plus-outline" type="text" @click="dialogVisibleopen">
          {{$t('general.add')}}</el-button>
      </el-form-item>
      <el-form-item>
        <el-button class="el-icon-document" type="text" @click="handlePrint">{{$t('general.print')}}
        </el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" highlight-current-row border style="width: 100%" :empty-text="$t('general.empty_data')">
      <el-table-column :label="$t('empIns10de.logicid')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns10de.insuranceid')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.insurance_id }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('empIns10de.name')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.insurance.emplist.name }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('empIns10de.leavetime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.leavetime | formatDate }}</span>
        </template>

      </el-table-column>

      <el-table-column :label="$t('empIns10de.createtime')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.createtime | formatDate }}</span>
        </template>

      </el-table-column>

      <el-table-column :label="$t('general.operation')" align="center" fixed="right" width="300">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">
            {{$t('general.edit')}}</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.$index, scope.row)">
            {{$t('general.delete')}}</el-button>

        </template>
      </el-table-column>
    </el-table>

    <!--add-->

    <el-dialog :title="$t('general.add')" :append-to-body="true" :visible.sync="dialogVisible" width="50%"
      :before-close="handleClose">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left:50px">
        <el-row>
          <el-col :span="12">
            <div>

              <el-form-item :label="$t('empIns10de.selectemployee')">
                <el-select v-model="ruleForm.insurance_id" style="margin-left:10px;width: 185px" size="mini"
                  no-data-text="データなし" @change="idSelected" placeholder="">
                  <el-option v-for="item in optionsinsurance" :key="item.insurance_id" :label="item.insurance_id"
                    :value="item.insurance_id"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('empIns10de.name')">
                {{username}}
              </el-form-item>

            </div>
          </el-col>

          <el-col :span="12">
            <div>

              <el-form-item :label="$t('empIns10de.leavetime')" prop="">
                <el-date-picker v-model="ruleForm.leavetime" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" placeholder=""></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('empIns10de.createtime')" prop="">
                <el-date-picker v-model="ruleForm.createtime" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" placeholder=""></el-date-picker>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="insertEmplns10('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>

    </el-dialog>

    <!--edit-->
    <el-dialog :title="$t('general.edit')" :append-to-body="true" :visible.sync="dialogUpdate" width="50%"
      :before-close="handleClose">

      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" size="medium"
        :label-position="labelPosition" style="margin-left:50px">

        <el-row>
          <el-col :span="12">
            <div>
              <el-form-item :label="$t('empIns10de.logicid')">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.id" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px" placeholder=""></el-input>
              </el-form-item>
              <el-form-item :label="$t('empIns10de.insuranceid')">
                <el-input prefix-icon="el-icon-edit" v-model="ruleForm.insurance_id" size="mini" readonly="readonly"
                  style="margin-left:10px;width: 185px" placeholder=""></el-input>
              </el-form-item>

            </div>
          </el-col>

          <el-col :span="12">
            <div>

              <el-form-item :label="$t('empIns10de.leavetime')" prop="">
                <el-date-picker v-model="ruleForm.leavetime" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" placeholder=""></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('empIns10de.createtime')" prop="">
                <el-date-picker v-model="ruleForm.createtime" size="mini" value-format="yyyy-MM-dd"
                  style="margin-left:10px;width: 185px" type="date" placeholder=""></el-date-picker>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button style="width:120px" @click="updateEmplns10('ruleForm')" type="primary" size="medium">
          {{$t('general.confirm')}}
        </el-button>
        <el-button style="width:120px" @click="s1_cancel('ruleForm')" size="medium">{{$t('general.cancel')}}
        </el-button>
      </span>

    </el-dialog>

    <br />
    <div class="pages">
      <el-pagination background :disabled="disablePage" :current-page.sync="currentPage" small
        layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="handleCurrentChange">
      </el-pagination>
    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        labelPosition: "left",
        depss: [],
        emp: [],
        username: "",
        optionsinsurance: [],


        ruleForm: {
          id: "",
          insurance_id: "",
          createtime: "",
          leavetime: ""
        },

        tableData: [],
        search: "",
        dialogVisible: false,
        dialogUpdate: false,
        dialogDetails: false,
        pageSize: 6,
        currentPage: 1,
        total: 0,
        disablePage: false
      };
    },
    methods: {
      handleEdit(index, row) {
        this.dialogUpdate = true;
        // let week_work_time = row.week_work_time.slice(0,2);
        // let shutoku_date = row.shutoku_date | formatDate;

        this.ruleForm.id = row.id,
          this.ruleForm.insurance_id = row.insurance_id,
          this.ruleForm.createtime = row.createtime,
          this.ruleForm.leavetime = row.leavetime
      },

      dialogVisibleopen() {
        this.emptyUserData();
        this.dialogVisible = true;
      },

      handleDetails(index, row) {
        this.dialogDetails = true;
        this.ruleForm = Object.assign({}, row);
      },
      handlePrint() {
        this.axios({
          method: "post",
          url: "/printEmpIns10"
        }).then(response => {

          this.$message({
            type: "success",
            message: this.$t("general.print_completed"),
          });

        })
          .catch(error => {
            this.$message({
              type: "warning",
              message: this.$t("general.print_failed"),
            });
          });
      },
      handleClose(done) {
        this.$confirm(this.$t("general.close_comfirm"), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t("general.confirm"),
          cancelButtonText: this.$t("general.cancel"),
          type: "warning"
        })
          .then(_ => {
            this.emptyUserData();
            done();
          })
          .catch(_ => { });
      },
      handleDelete(index, row) {
        // console.log(index, row);
        this.$confirm(this.$t('general.sure_delete'), {
          cancelButtonClass: "btn-custom-cancel",
          confirmButtonClass: "btn-custom-confirm",
          confirmButtonText: this.$t('OK'),
          cancelButtonText: this.$t('general.cancel'),
          type: "warning"
        })
          .then(() => {
            let postData = this.qs.stringify({
              str: row.insurance_id
            });
            this.axios({
              method: "post",
              url: "/deleteEmplns10",
              data: postData
            })
              .then(response => {

                this.axios
                  .post("/ListEmpIns10")
                  .then(response => {
                    this.tableData = response.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
                this.$message({
                  type: "success",
                  message: this.$t("general.delete_completed"),
                });

              })
              .catch(error => {
                console.log(error);
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "cancel"
            });
          });
      },

      s1_cancel(ruleForm) {
        // console.log("thisdate");
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
        this.$refs[ruleForm].resetFields();
      },
      cancel() {
        // console.log("thisdate");
        this.dialogUpdate = false;
        this.dialogVisible = false;
        this.dialogDetails = false;
        this.emptyUserData();
      },
      emptyUserData() {
        this.ruleForm = {
          id: "",
          insurance_id: "",
          createtime: "",
          leavetime: ""

        };
      },



      insertEmplns10(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify({

              insurance_id: this.ruleForm.insurance_id,
              createtime: this.ruleForm.createtime,
              leavetime: this.ruleForm.leavetime
            });
            // console.log(postData);
            this.axios({
              method: "post",
              url: "/insertEmplns10",
              data: postData
            })
              .then(response => {
                this.axios
                  .post("/ListEmpIns10")
                  .then(response => {
                    this.tableData = response.data;
                    this.dialogVisible = false;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.delete_completed"),
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.canceled"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      updateEmplns10(ruleForm) {
        this.$refs[ruleForm].validate((valid) => {
          if (valid) {
            let postData = this.qs.stringify(this.ruleForm);
            // console.log(postData);
            this.axios({
              method: "post",
              url: "/updateEmplns10",
              data: postData
            })
              .then(response => {
                this.axios
                  .post("/ListEmpIns10")
                  .then(response => {
                    this.tableData = response.data;
                    this.dialogUpdate = false;
                    this.currentPage = 1;
                    this.$message({
                      type: "success",
                      message: this.$t("general.edit_completed"),
                    });
                  })
                  .catch(error => {
                    this.$message({
                      type: "warning",
                      message: this.$t("general.edit_failed"),
                    });
                    console.log(error);
                  });
                this.getPages();
                this.dialogVisible = false;
                // console.log(response);
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            console.log("error submit!!");
            this.$message({
              type: "error",
              message: this.$t("general.valid_failed")
            });
            return false;
          }
        });
      },
      refreshData() {
        location.reload();
      },
      idSelected() {

        let id = this.qs.stringify({
          id: this.ruleForm.insurance_id
        });
        this.axios({
          method: "post",
          url: "/getusername",
          data: id
        }).then(response => {

          this.username = response.data;


        })
          .catch(error => {
            console.log(error);
          });

      },

    },


    created() {
      this.axios
        .post("/ListEmpIns10")
        .then(response => {

          this.tableData = response.data;

        })
        .catch(error => {
          // this.show = false;
          // this.$message({ type: 'error', message: '開発中です。' });
          // console.log(error);
        });
      this.axios
        .post("/ListInsurance")
        .then(response => {
          this.optionsinsurance = response.data;
          // console.log(this.tabledata);
        })
        .catch(error => {
          console.log(error);
        });



    },

  };
</script>


<style>
  .btn-custom-cancel {
    float: right;
    margin-left: 10px;
    width: 90px;
  }

  .btn-custom-confirm {
    width: 90px;
  }
</style>
<style scoped>
  .search_name {
    width: 200px;
  }

  .pages {
    margin: 0px;
    padding: 0px;
    text-align: right;
  }

  .style1 {
    margin-right: 90px;
    padding: 0px;
    text-align: right;
  }
</style>


// WEBPACK FOOTER //
// src/components/EmpIns/EmpIns10.vue